import React from "react";
import PaymentsAppSwitcher from "./PaymentsAppSwitcher";
import ZomentumLogo from "../../../Assets/PaymentsAppHeader/ZomentumLogo.svg";
import Notification from "../Notification";
import IntegrationReAuthBanner from "./IntegrationReAuthBanner";
import MessageBanner from "./MessageBanner";
import AnnouncementModal from "../AnnouncementModal";

const PaymentsAppHeader: React.FC = () => {
  return (
    <div className="relative">
      <MessageBanner />
      <AnnouncementModal />
      <nav className="sticky header h-16 flex z-30">
        <PaymentsAppSwitcher />
        <div className="flex flex-grow items-center justify-between">
          <a href="/getting-started" className="flex items-center justify-center ml-4">
            <img src={ZomentumLogo} alt="Zomentum" className="h-5" />
          </a>
          <IntegrationReAuthBanner />
          <Notification />
        </div>
      </nav>
    </div>
  );
};

export default PaymentsAppHeader;
